import { Link } from "react-router-dom";

const entries = [
  {
    to: "/category/tv",
    icon: "ri-live-line",
    title: "电视剧",
    desc: "热播剧集与剧情速览",
    tone: "primary" as const,
  },
  {
    to: "/category/movie",
    icon: "ri-film-line",
    title: "电影",
    desc: "佳片推荐与口碑解析",
    tone: "accent" as const,
  },
  {
    to: "/actors",
    icon: "ri-user-star-line",
    title: "热门演员",
    desc: "演员资料与代表作品",
    tone: "secondary" as const,
  },
  {
    to: "/search",
    icon: "ri-search-eye-line",
    title: "我要选片",
    desc: "按条件筛选想看的内容",
    tone: "secondary" as const,
  },
];

const toneClass: Record<string, string> = {
  primary: "bg-primary-100 text-primary-700",
  accent: "bg-accent-100 text-accent-700",
  secondary: "bg-secondary-100 text-secondary-700",
};

export default function QuickEntries() {
  return (
    <section className="w-full px-4 md:px-8 -mt-8 relative z-20">
      <div className="grid grid-cols-2 lg:grid-cols-4 gap-3 md:gap-4">
        {entries.map((e) => (
          <Link
            key={e.to}
            to={e.to}
            className="group flex items-center gap-3 p-4 bg-background-50 rounded-lg border border-background-200 hover:border-primary-200 transition-colors cursor-pointer"
          >
            <span
              className={`w-11 h-11 shrink-0 flex items-center justify-center rounded-lg text-xl ${toneClass[e.tone]}`}
            >
              <i className={e.icon}></i>
            </span>
            <span className="min-w-0">
              <span className="block font-heading font-semibold text-sm md:text-base text-foreground-950 group-hover:text-primary-600 transition-colors whitespace-nowrap">
                {e.title}
              </span>
              <span className="block text-xs text-foreground-500 truncate">{e.desc}</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}